export const INJECT_REFRESH_REQUEST = "INJECT_REFRESH_START";
export const INJECT_REFRESH_SUCCESS = "INJECT_REFRESH_SUCCESS";
